import { render, staticRenderFns } from "./DemoSignUp.vue?vue&type=template&id=30957fa0&"
import script from "./DemoSignUp.vue?vue&type=script&lang=js&"
export * from "./DemoSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports